var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"mb-3"},[_vm._v("\n  Not implemented.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }